export default "__VITE_ASSET__14d71d06__"